<template>
  <button :disabled="loading"
    class="w-full p-2 rounded text-white bg-gray-600 dark:text-gray-800 dark:bg-white"
    :class="{ 'hover:bg-gray-500 active:bg-gray-650 dark:hover:bg-gray-200 dark:active:bg-gray-300'
      : !loading }">
        <slot v-if="!loading" />
        <spinner v-else class="mx-auto" />
  </button>
</template>

<script>
import Spinner from './Spinner.vue';

export default {
  components: {
    Spinner,
  },
  props: {
    loading: {
      type: Boolean,
      required: true,
    },
  },
};
</script>
